import React, { useEffect, useState } from 'react';
import { HuchaPosventaValues, HuchaVentaValues } from '../models/hucha-values';
import { handleGeneratePDF, pdfDownloaded } from '../../../../../helpers/pdf-generator';
import { useBonoPosventaTracker } from '../../bono-posventa/hooks/use-bono-posventa-tracker';
import { useHuchaTracker } from '../../hucha-venta/hooks/use-hucha-tracker';

const getHuchaPdfFilename = (huchaValues: HuchaVentaValues | HuchaPosventaValues | null): string => {
	if (huchaValues?.huchaType === 'posventa') {
		return `Club Volkswagen - Bono Taller - ${huchaValues?.idUser}.pdf`;
	}

	const discountType = huchaValues?.huchaTier !== 'standard' ? 'Renovadores' : 'Hucha';
	return `Club Volkswagen - ${discountType} - ${huchaValues?.idUser}.pdf`;
};

// hook para generar el PDF y manejar su estado
export const useHuchaPdfGenerator = (
	huchaValues: HuchaVentaValues | HuchaPosventaValues | null,
	externalRef?: React.RefObject<HTMLDivElement>,
) => {
	const internalRef = React.useRef<HTMLDivElement>(null); // ref interno si no se pasa uno
	const targetRefPDF = externalRef || internalRef;

	const isPosventa = huchaValues?.huchaType === 'posventa';
	const { trackDownloadAhorroAcumulado } = useHuchaTracker(
		(huchaValues as HuchaVentaValues | null)?.huchaTier ?? 'standard',
	);
	const { trackDownloadBonoTaller } = useBonoPosventaTracker();
	const trackDownload = isPosventa ? trackDownloadBonoTaller : trackDownloadAhorroAcumulado;

	const [isPdfReady, setIsPdfReady] = useState(false);

	// sincronizar el estado local con el BehaviorSubject
	const [isDownloading, setIsDownloading] = useState(pdfDownloaded.getValue());

	// suscripción al Subject para que el booleano sea reactivo
	useEffect(() => {
		const subscription = pdfDownloaded.subscribe((value) => {
			setIsDownloading(value);
		});
		return () => subscription.unsubscribe();
	}, []);

	const generatePdf = async () => {
		handleGeneratePDF(targetRefPDF, setIsPdfReady, getHuchaPdfFilename(huchaValues));
	};

	// click de descarga
	const handlePdfDownloadClick = () => {
		if (isDownloading) return;
		trackDownload();
		generatePdf();
	};

	return { handlePdfDownloadClick, isDownloading, isPdfReady };
};
